
import { mixins, Options } from 'vue-class-component';
import { DATA_WIDGET_VALUE } from '@/common/constants';
import LoadingScreen from '@/components/LoadingScreen.vue';
import MCampaignPopup from '@/components/MCampaignPopup.vue';
import CampaignWidgetMixin from '@/mixins/campaignWidget';

@Options({
  components: {
    MCampaignPopup,
    LoadingScreen
  }
})
export default class MCampaign extends mixins(CampaignWidgetMixin) {
  // @dev: don't change this, it makes sure the outer divs get classes that
  //       contain your expected data-widget value no matter what
  DATA_WIDGET_VALUE: string = DATA_WIDGET_VALUE;

  // @dev: start here by replacing the data and functions with your own stuff
  toggle = true;
  popupIsOpen = false;
  htmlOverflowInitial: string | undefined;
  bodyOverflowInitial: string | undefined;

  get disabled() {
    return this.state.wrongChain || !this.state.walletAddress;
  }

  get buttonText() {
    if (!this.state.walletAddress) {
      return this.connectWalletText ? this.connectWalletText : 'Connect Wallet to Claim';
    }
    return this.claimText ? this.claimText : 'Claim';
  }

  openPopup() {
    this.popupIsOpen = true;
  }

  close() {
    this.popupIsOpen = false;
    document.documentElement.style.overflowY = this.htmlOverflowInitial!;
    document.body.style.overflowY = this.bodyOverflowInitial!;
  }

  async created() {
    this.htmlOverflowInitial = document.documentElement.style.overflowY;
    this.bodyOverflowInitial = document.body.style.overflowY;
    document.documentElement.style.overflowY = 'hidden !important';
    document.body.style.overflowY = 'hidden !important';
  }

  handleClick(): void {
    this.toggle = !this.toggle;

    // @dev: just a sanity check ensuring props are being fed into component
    // console.warn(this.appName);
  }
}
